<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>资金管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item><a @click="jumpTo('/giveAreaData')">服务商奖金释放设置</a></el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">

      <div class="contain_header clr">
        <el-form
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-row>
            <el-col :span="5">
              <!-- <el-form-item label='服务商信息'>
                <el-input
                  style="width:300px"
                  v-model="filters.title"
                  placeholder="请输入服务商信息"
                >
                </el-input>
              </el-form-item> -->
              <el-form-item label='选择服务商'>
              <el-select
                  clearable
                  v-model="filters.userId"
                  placeholder="请选择"
                >
                <el-option
                  v-for="option in userOptions"
                  :value="option.id"
                  :key='option.id'
                  :label="option.username"
                ></el-option>
              </el-select>
              </el-form-item>

              
            </el-col>
            <el-col :span="5">
              <el-form-item label="选择季度">
                <el-select
                  clearable
                  v-model="filters.hasU"
                  placeholder="请选择"
                >
                  <el-option
                    label="2022一季度"
                    value="2022-01"
                  ></el-option>
                 <el-option
                    label="2022二季度"
                    value="2022-02"
                  ></el-option>
                  <el-option
                    label="2022三季度"
                    value="2022-03"
                  ></el-option>
                  <el-option
                    label="2022四季度"
                    value="2022-04"
                  ></el-option>
                  <el-option
                    label="2023一季度"
                    value="203-01"
                  ></el-option>
                 <el-option
                    label="2023二季度"
                    value="2023-02"
                  ></el-option>
                  <el-option
                    label="2023三季度"
                    value="2023-03"
                  ></el-option>
                  <el-option
                    label="2023四季度"
                    value="2023-04"
                  ></el-option>

                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item label="选择类型">
                <el-select
                  clearable
                  v-model="filters.infoType"
                  placeholder="请选择"
                >
                  <el-option
                    label="目标奖励"
                    value="1"
                  ></el-option>
                 <el-option
                    label="个人奖励"
                    value="2"
                  ></el-option>
                  <el-option
                    label="直属奖励"
                    value="3"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item>
                <el-button
                  type="primary"
                  @click="handleSearchM"
                >搜索</el-button>


                <!-- <el-button
                  style="margin-left:10px"
                  @click="excelOut"
                  type="primary"
                  size="small"
                >导出</el-button> -->

              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </div>

      <div
        class="contain_body"
      >
        <!-- <div class="contain_body_head">
          <el-button
                  type="primary"
                  @click="editUpInfo(null, 2)"
                >批量设置服务商</el-button>
          已选中：{{chooseName}}
        </div> -->
        <el-table
          :data="tableData"
          v-loading='tableDataLoading'
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >
        <!-- <el-table-column
          type="selection"
          width="55">
        </el-table-column> -->

        <el-table-column
            prop="username"
            label="服务商信息"
          >
          <template slot-scope="scope">
            <span v-if="scope.row.username == null">暂无</span>
            <span v-else>{{scope.row.username}}({{scope.row.telephone}})</span>
          </template>

          </el-table-column>

          <el-table-column
            prop="quarter_num"
            label="季度"
          >

          </el-table-column>

          <el-table-column
            prop="total_money"
            label="总金额"
          >

          </el-table-column>

          <el-table-column
            prop="release_money"
            label="释放金额"
          >

          </el-table-column>

          <el-table-column
            prop="info_type"
            label="类型"
            :formatter="formatterStatus"
          >
          </el-table-column>

          <el-table-column
            prop="release_money"
            label="季度考核"
          >
          <template slot-scope="scope">
            <span>新增门店{{scope.row.store_num}}人，新增代理{{scope.row.work_num}},比例：{{(scope.row.cutM * 100).toFixed(2)}}%</span>
            <span v-if="scope.row.cut_num <= scope.row.cutM">考核指标：{{scope.row.cut_num * 100}}%</span>
            <span v-else style="color:red">考核指标：{{scope.row.cut_num * 100}}%</span>
          </template>
          </el-table-column>

          <el-table-column
            prop="status"
            label="状态"
          >
           <template slot-scope="scope">
            <span v-if="scope.row.status == 1">投诉暂停释放</span>
            <span v-if="scope.row.status == 2">已完成</span>
          </template>
</el-table-column>
          

          <!-- <el-table-column
            label="操作"
            align='center'
          >
            <template slot-scope="scope">
              <el-button
                v-if="hasPower('50161888')"
                @click="editUpInfo(scope.row, 1)"
                type="text"
              >释放金额</el-button>


            </template>
          </el-table-column> -->
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>

      </div>

    </div>

    <el-dialog title="释放金额" :visible.sync="editUpInfoDialog" width="40%">
      <el-form label-position="top" class="m-search" size="small" :model="form2" ref="form2"> 
        <el-form-item label="释放金额">
          
          <el-input
                  style="width:300px"
                  v-model="form2.userId"
                  placeholder="请输入释放金额"
                >
                </el-input>
          
        </el-form-item>


        <el-form-item>
          <el-button type="primary" @click="throwGroupUp11()" :loading="ceoLoading1">提交</el-button>
          <el-button @click="editUpInfoDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </el-main>

</template>


<script>
import AMap from "AMap";
import { bus } from "../../bus.js";
import API from "../../api/api_user";
var _ = require("lodash");
export default {
  name: "giveAreaData",
  created() {},
  data() {
    return {
      tableDataLoading: false,
      addLoading: false,
      editUpInfoDialog:false,
      form2:{
        ids:null,
        userId:null,
      },
      ceoLoading1:false,
      cluster:null,
      filters: {
        userId:null,
        hasU:null,
        infoType:null,
        title: null,
        userInfo: null,
        status: null,
        province: null,
        city: null,
        district: null,
        userType: null
      },
      chooseName:'',
      chooseNameIds:'',
      dialogEditVisible: false,
      dialogBalanceVisible: false,
      addBalanceLoading: false,
      page_num: 1,
      map: null,
      keywords: "",
      provinceOptions: [],
      userOptions:[],
      cityOptions: [],
      districtOption: [],
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight:null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    let that = this;
    

      API.getDisManager({ token: localStorage.getItem("api_token") })
      .then(
        function(result) {
          if (result.key == 1000) {
            that.userOptions = result.result.list;
          } else if (result.key == 1001) {
            bus.$emit("goto", "/login");
          } else {
            that.$message.error({
              showClose: true,
              message: result.message || "登录失败",
              duration: 2000
            });
          }
        },
        function(err) {
          console.error(err);
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error) {
        console.error(error);
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
    this.handleSearch();
  },
  methods: {
    formatterStatus(row, column) {
      if (row.info_type == 1) {
        return "目标奖励";
      } else if (row.info_type == 2) {
        if (row.up_id != null)
        {
          return "给" + row.up_name + '的直属奖励';
        } else
        {
          return "个人奖励";
        }
      } 
    },
    handleSelectionChange(row){
      if (row != null && row.length > 0)
      {
        var name = [];
        var id = [];
        row.forEach(items => {
          name.push(items.city_name + items.name);
          id.push(items.id)
        });
        this.chooseName = name.join(',');
        this.chooseNameIds = id.join(',');
      } else
      {
        this.chooseName = '';
        this.chooseNameIds = '';
      }
    },
    editUpInfo(row, type) {
      
        this.form2.userId = null;
        this.form2.ids = row.id;
        this.editUpInfoDialog = true;
    },
    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/shop_list_excel?token=" +
        localStorage.getItem("api_token");
        if (that.filters.status) {
        url = url + "&role_type=" + that.filters.status;
      }
      if (that.filters.title) {
        url = url + "&keyword=" + that.filters.title;
      }
      if (that.filters.userInfo) {
        url = url + "&userInfo=" + that.filters.userInfo;
      }
      if (that.filters.keyword) {
        url = url + "&keyword=" + that.filters.keyword;
      }
      if (that.filters.city) {
        url = url + "&city=" + that.filters.city;
      }
      if (that.filters.district) {
        url = url + "&district=" + that.filters.district;
      }
      var provinceList = localStorage.getItem("provinceList")
      if (provinceList != null && provinceList != '')
      {
        url = url + "&province=" + that.filters.provinceList;
      } else if (that.filters.province) {
        url = url + "&province=" + that.filters.province;
      }
      top.location.href = url;
    },
    formatterRoleType(row, column) {
      var word = "";
      if (row.role_type == -1) {
        word = "无";
      } else if (row.role_type == -0.5) {
        word = "康减系列vip会员";
      } else if (row.role_type == -0.4) {
        word = "康减系列高级会员";
      } else if (row.role_type == -0.3) {
        word = "康减系列荣誉会员";
      } else if (row.role_type == 0) {
        word = "VIP门店";
      } else if (row.role_type == 1) {
        word = "联盟店";
      } else if (row.role_type == 2) {
        word = "市代";
      } else if (row.role_type == 3) {
        word = "省代";
      } else if (row.role_type == 4) {
        word = "CEO";
      } else if (row.role_type == 1.1) {
        word = "康减系列市代";
      } else if (row.role_type == 2.1) {
        word = "康减系列省代";
      } else if (row.role_type == 3.1) {
        word = "康减系列CEO";
      } else if (row.role_type == 1.05) {
        return "优秀联盟店";
      } else if (row.role_type == 5) {
        return "总经销商";
      } else if (row.role_type == 2.2) {
        return "合伙人";
      } else if (row.role_type == 4.2) {
        return "董事";
      } else if (row.role_type == 5.1) {
        return "区域总监";
      } else if (row.role_type == 5.2) {
        return "城市加盟商";
      } else if (row.role_type == 4.8) {
        return "经销商";
      }
      if (row.special_status == 2) {
        word = word + '-' + '特殊';
      }
      return word;
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    throwGroupUp11() {
      var that = this;
      if (
        !that.form2.userId ||
        that.form2.userId == null
      ) {
        that.$message.error({
          showClose: true,
          message: "请输入释放金额",
          duration: 2000
        });
        return;
      }
        that.ceoLoading1 = true;
        let para = {
          token: localStorage.getItem("api_token"),
          logId: that.form2.ids,
          money: that.form2.userId
        };
        API.release_money(para)
          .then(
            function(result) {
              that.ceoLoading1 = false;
              if (result && parseInt(result.key) === 1000) {
                that.$message.success({
                  showClose: true,
                  message: "释放成功",
                  duration: 1500
                });
                that.editUpInfoDialog = false;
                that.search();
              } else {
                that.$message.error({
                  showClose: true,
                  message: result.message,
                  duration: 2000
                });
              }
            },
            function(err) {
              that.ceoLoading1 = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.addLoading = false;
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
    },


    handleSearchM(){
      this.handleSearch();
    },
    handleSearch() {
      this.page_size = 20;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;
      let params = {
        page_num: that.page_num,
        page_size: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.title) {
        params.keyword = that.filters.title;
      }
      
      if (that.filters.hasU) {
        params.qu = that.filters.hasU;
      }
      if (that.filters.infoType) {
        params.infoType = that.filters.infoType;
      }
      if (that.filters.province) {
        params.province = that.filters.province;
      }
      if (that.filters.city) {
        params.city = that.filters.city;
      }
      if (that.filters.district) {
        params.district = that.filters.district;
      }
      if (that.filters.userId) {
        params.userId = that.filters.userId;
      }
      var provinceList = localStorage.getItem("provinceList")
      if (provinceList != null && provinceList != '')
      {
        params.province = provinceList;
      }
      that.tableDataLoading = true;
      API.give_area_list(params)
        .then(
          function(result) {
            that.tableDataLoading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  if (result.result.list[i].store_num != null && result.result.list[i].work_num != null) {
                      if (result.result.list[i].store_num == 0)
                      {
                        result.result.list[i].cutM = 0;//完成指标为0
                      } else {
                        result.result.list[i].cutM = ((result.result.list[i].work_num / result.result.list[i].store_num) );
                      }
                  }
                }
              }
              that.tableData = result.result.list;
            }
          },
          function(err) {
            that.tableDataLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.tableDataLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.amap-wrapper1 {
  padding: 30px;
  width: 1100px;
  height: 500px;
}
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/giveAreaData.vue